import { Button, Card, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "../../config/authaxios";
import Nabvar from "../../common/Nabvar";
import Sidebar from "../../common/Sidebar";
import Body from "../../ui/Body";
import DiscountMasterSwitch from "../discount/DiscountMasterSwitch";


export default function Configmeta() {
  const [configData, setConfigData] = useState({});

  // theme context
  let navigate = useNavigate();
  const vht = useSelector((state) => state.qwickSilver);

  const editHandler = () => {
    navigate('/editconfigmeta')
  }

  const fetchConfigMeta = () => {
    axios.get('/admin/config-meta').then((res) => {
      if (res.status == 200) {
        // console.log(res.data.response)
        let data = res.data.response
        // console.log("data-->",data)
        setConfigData(data)
      }


    })
  }

  useEffect(() => {
    fetchConfigMeta()
  }, [])

  return (
    <>
      {/* navigation section */}
      <Sidebar />
      <Nabvar />

      <Body>
        <Card sx={{ p: 4 }}>
          <Stack spacing={2}>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'> App version :</Typography>
              <Typography variant='h6'>{configData.app_version}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>Is Vouchar Uploading :</Typography>
              <Typography variant='h6'>{configData?.is_voucher_uploading ? "True" : "False"}</Typography>
            </Stack>

            {/* <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>Popular Vouchar Count :</Typography>
              <Typography variant='h6'>{configData?.popular_voucher_count}</Typography>
            </Stack> */}
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>KA Cash Payment Redeem Limit :</Typography>
              <Typography variant='h6'>{configData?.available_cash_ka_redeem_count}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>QC Cash Payment Redeem Limit :</Typography>
              <Typography variant='h6'>{configData?.available_cash_qw_redeem_count}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>GP Cash Payment Redeem Limit :</Typography>
              <Typography variant='h6'>{configData?.available_cash_co_redeem_count}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>Qwik redeem Feature Status :</Typography>
              <Typography variant='h6'>{configData?.qwik_redeem_feature_status ? "True" : "False"}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>ka Redeem Feature Status :</Typography>
              <Typography variant='h6'>{configData?.ka_redeem_feature_status ? "True" : "False"}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>Redeem Rules :</Typography>
              <Typography variant='h6'>{configData?.redeem_rules}</Typography>
            </Stack>


            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>Coupon Redeem Feature Status :</Typography>
              <Typography variant='h6'>{configData?.coupon_redeem_feature_status ? "True" : "False"}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>KA GC Redeem Limit :</Typography>
              <Typography variant='h6'>{configData?.available_ka_redeem_count}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>GP GC Redeem Limit :</Typography>
              <Typography variant='h6'>{configData?.available_co_redeem_count}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>QC GC Redeem Limi :</Typography>
              <Typography variant='h6'>{configData?.available_qw_redeem_count}</Typography>
            </Stack>
            
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'> Is Qwik Product Show :</Typography>
              <Typography variant='h6'>{configData?.is_qwik_product_show ? "True" : "False"}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>Otp Send Attempts :</Typography>
              <Typography variant='h6'>{configData?.otp_send_attempts}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>Otp Send Reset Hours :</Typography>
              <Typography variant='h6'>{configData?.otp_send_reset_hours}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>OTP Varify Attempts :</Typography>
              <Typography variant='h6'>{configData?.otp_varify_attempts}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>Chat Support Number :</Typography>
              <Typography variant='h6'>{configData?.chat_support_number}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>tpx_ka_order_limit :</Typography>
              <Typography variant='h6'>{configData?.tpx_ka_order_limit}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>tpx_co_order_limit :</Typography>
              <Typography variant='h6'>{configData?.tpx_co_order_limit}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>tpx_qw_order_limit :</Typography>
              <Typography variant='h6'>{configData?.tpx_qw_order_limit}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>phonepe_enabled :</Typography>
              <Typography variant='h6'>{configData?.phonepe_enabled ? "True" : "False"}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>free_cash_enabled :</Typography>
              <Typography variant='h6'>{configData?.free_cash_enabled ? "True" : "False"}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>free_cash_enabled :</Typography>
              <Typography variant='h6'>{configData?.free_cash_enabled ? "True" : "False"}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>order_failed_limit :</Typography>
              <Typography variant='h6'>{configData?.order_failed_limit ?  configData?.order_failed_limit : 0}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>upi_redeem_feature_status :</Typography>
              <Typography variant='h6'>{configData?.upi_redeem_feature_status ?  'True' : 'False'}</Typography>
            </Stack>
            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>is_upi_voucher_uploading :</Typography>
              <Typography variant='h6'>{configData?.is_upi_voucher_uploading ?  'True' : 'False'}</Typography>
            </Stack>
            {/* upi_current_balance */}

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>upi_current_balance :</Typography>
              <Typography variant='h6'>{configData?.upi_current_balance ?  configData?.upi_current_balance : '---'}</Typography>
            </Stack>
            {/* <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>pro_order_amount_limit :</Typography>
              <Typography variant='h6'>{configData?.pro_order_amount_limit ?  configData?.pro_order_amount_limit : '---'}</Typography>
            </Stack> */}

            {/* <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>pro_voucher_order_limit :</Typography>
              <Typography variant='h6'>{configData?.pro_voucher_order_limit ?  configData?.pro_voucher_order_limit : '---'}</Typography>
            </Stack> */}






            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>daily_slots :</Typography>
              <Typography variant='h6'>{configData?.daily_slots ?  configData?.daily_slots : '---'}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>daily_slot_order_amount_limit :</Typography>
              <Typography variant='h6'>{configData?.daily_slot_order_amount_limit ?  configData?.daily_slot_order_amount_limit : '---'}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>extended_amount_in_slot_no :</Typography>
              <Typography variant='h6'>{configData?.extended_amount_in_slot_no ?  configData?.extended_amount_in_slot_no : '---'}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>extended_amount_date :</Typography>
              <Typography variant='h6'>{configData?.extended_amount_date ?  configData?.extended_amount_date : '---'}</Typography>
            </Stack>

            <Stack direction='row' spacing={2} alignItems='center'>
              <Typography color='primary'>daily_slot_order_amount_extended_limit :</Typography>
              <Typography variant='h6'>{configData?.daily_slot_order_amount_extended_limit ?  configData?.daily_slot_order_amount_extended_limit : '---'}</Typography>
            </Stack>

            <DiscountMasterSwitch
              configId={configData._id}
              enabled={configData.coupon_discount_master_enabled !== false}
              onUpdated={fetchConfigMeta}
            />
            
          </Stack>
        </Card>
        <Button sx={{ mt: 2 }} variant="contained" onClick={editHandler}>Edit configmeta</Button>
      </Body>
    </>
  );
}
